// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql, } from 'react-relay'

const addMutation = graphql`
    mutation TVShowAddMutation(
        $input: TVShowAddInput!
    ) {
        TVShowAdd(input: $input) {
            tvshowEdge {
                node {
                    id
                }
            }
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment, 
        {
            mutation: addMutation,
            variables: {
                input: params
            },
            onCompleted: (response) =>{
                console.log("mutation complete")
                console.log(response)
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null)
                    return
                }

                callback(null, response.TVShowAdd.tvshowEdge.node.id)
            },
            onError: (error) => {
                console.log("error mutating")
                console.log(error)
                callback(error, null)
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/TVShowAddMutation.js